import React, { useMemo, useState, useEffect } from "react";
import "../client/Client.css"; // reuse common table/layout styles
import "./Leaves.css";
import config from "../../config";
import { FiSearch } from "react-icons/fi";
import { BsSliders } from "react-icons/bs";
import Header from "../../components/common/Header";


const Leaves = ({ setActivePage }) => {
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [tab, setTab] = useState("history");
  const [showFilter, setShowFilter] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [selectedClientId, setSelectedClientId] = useState('');
  const [clientList, setClientList] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const orgId = localStorage.getItem("orgId") || "";
  const itemsPerPage = 8;
  const [requestStatus, setRequestStatus] = useState(new Map());
  const [userDetails, setUserDetails] = useState({ name: "", role: "" });

  // Get the name of the selected client for the empty state message
  const selectedClientName = useMemo(() => {
    const client = clientList.find(c => String(c.clientKey) === String(selectedClientId));
    return client ? client.name : "";
  }, [selectedClientId, clientList]);

  useEffect(() => {
    const orgId = localStorage.getItem("orgId") || "";
    const token = localStorage.getItem("Authorization") || "";
    const firstName = localStorage.getItem("firstName") || "";
    const lastName = localStorage.getItem("lastName") || "";
    const role = localStorage.getItem("role")?.toUpperCase() || "GUEST";
    setUserDetails({
      name: `${firstName} ${lastName}`.trim(),
      role,
      token,
      orgId
    });
  }, []);
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const orgId = userDetails.orgId;
        if (!orgId || !userDetails.token) return;

        const response = await fetch(
          `${config.API_BASE_URL}${config.CLIENT_LIST_ENDPOINT}${orgId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${userDetails.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch clients");
        }

        const data = await response.json();

        // API response array-ah irukum nu assume panren
        setClientList(Array.isArray(data.body) ? data.body : []);

      } catch (error) {
        console.error("Client fetch error:", error);
        setClientList([]);
      }
    };

    fetchClients();
  }, [userDetails.orgId, userDetails.token]);


  useEffect(() => {
    if (!userDetails.orgId || !selectedClientId) {
      setLeaves([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    // URL construction
    let url = `${config.API_BASE_URL}${config.LEAVES_LIST_ENDPOINT}?orgKey=${userDetails.orgId}&clientKey=${selectedClientId}`;

    if (sortBy === "newest") url += "&sortBy=createdAt&sortOrder=DESC";
    if (sortBy === "oldest") url += "&sortBy=createdAt&sortOrder=ASC";
    if (filterStatus) url += `&status=${filterStatus}`;

    console.log("Fetching with Filters:", url);

    fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${userDetails.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setLeaves(Array.isArray(data.body) ? data.body : []);
        setLoading(false);
      })
      .catch((e) => {
        setError(e.message);
        setLoading(false);
      });

    // Inga filters-ah add pannitom, so inime filter change aana auto-va call aagum
  }, [selectedClientId, userDetails.orgId, userDetails.token, sortBy, filterStatus]);



  const filtered = useMemo(() => {
    let data = [...leaves];

    const s = search.trim().toLowerCase();
    if (s) {
      data = data.filter(
        (r) =>
          (r.employeeName || "").toLowerCase().includes(s) ||
          (r.clientName || "").toLowerCase().includes(s) ||
          (r.leaveType || "").toLowerCase().includes(s) ||
          (r.status || "").toLowerCase().includes(s)
      );
    }

    // Status Filter
    if (filterStatus) {
      data = data.filter(
        (r) => (r.status || "").toLowerCase() === filterStatus.toLowerCase()
      );
    }

    // Sorting
    if (sortBy === "name") {
      data.sort((a, b) =>
        (a.employeeName || "").localeCompare(b.employeeName || "")
      );
    }

    if (sortBy === "startDate") {
      data.sort((a, b) =>
        new Date(a.startDate) - new Date(b.startDate)
      );
    }

    return data;
  }, [search, leaves, sortBy, filterStatus]);


  const totalPages = Math.max(1, Math.ceil(filtered.length / itemsPerPage));
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const current = filtered.slice(indexOfFirst, indexOfLast);

  const pageList = (currentPage, total, maxLength = 7) => {
    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
    const range = (s, e) => Array.from({ length: e - s + 1 }, (_, i) => s + i);
    const sideWidth = maxLength < 9 ? 1 : 2;
    const leftWidth = (maxLength - sideWidth * 2 - 3) >> 1;
    const rightWidth = (maxLength - sideWidth * 2 - 3) >> 1;
    if (total <= maxLength) return range(1, total);
    if (currentPage <= maxLength - sideWidth - 1 - rightWidth) {
      return [...range(1, maxLength - sideWidth - 1), '...', ...range(total - sideWidth + 1, total)];
    }
    if (currentPage >= total - sideWidth - 1 - rightWidth) {
      return [...range(1, sideWidth), '...', ...range(total - (sideWidth + leftWidth + rightWidth + 1), total)];
    }
    return [
      ...range(1, sideWidth),
      '...',
      ...range(currentPage - leftWidth, currentPage + rightWidth),
      '...',
      ...range(total - sideWidth + 1, total),
    ];
  };

  // ...existing code...

  return (
    <div>
      <Header
        title="Leave"
        subtitle="Leave Information"
        onProfileClick={() => setActivePage && setActivePage("Profile")}
      />
      {showFilter && (
        <div className="filter-overlay" onClick={() => setShowFilter(false)}>
          <div
            className="filter-card"
            onClick={(e) => e.stopPropagation()}
          >
            <h4>Filter</h4>

            <label>Sort By</label>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value=""></option>
              <option value="newest">Newest</option>
              <option value="oldest">Oldest</option>

            </select>

            {/* <label style={{ marginTop: "10px" }}>Status</label> */}
            {/* <select
        value={filterStatus}
        onChange={(e) => setFilterStatus(e.target.value)}
      >
        <option value="">All</option>
        <option value="ACCEPTED">Accepted</option>
        <option value="REJECTED">Rejected</option>
      </select> */}

            <div className="filter-buttons">
              <button
                className="clear-btn"
                onClick={() => {
                  setSortBy("");
                  setFilterStatus("");
                  setShowFilter(false);
                }}
              >
                Clear
              </button>

              <button
                className="apply-btn"
                onClick={() => {
                  // Just close the filter card. 
                  // The useEffect above will detect the change in sortBy/filterStatus automatically.
                  setShowFilter(false);
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="table-container">
        <div className="table-controls">
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center"
            }}
          >
            <FiSearch
              style={{
                position: "absolute",
                left: "12px",
                fontSize: "14px",
                color: "#999"
              }}
            />

            <input
              type="text"
              className="search-input"
              placeholder="Search"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
              style={{
                paddingLeft: "35px",
                width: "150px",
                height: "15px"
              }}
            />
          </div>
          <select
            className="search-input"
            style={{ width: '180px', height: '37px' }}
            value={selectedClientId}
            onChange={(e) => setSelectedClientId(e.target.value)}
          >
            <option value="">All Clients</option>
            {clientList.map(client => (
              <option key={client.clientKey} value={client.clientKey}>
                {client.name}
              </option>
            ))}
          </select>


          <div className="leave-header-actions">
            <div className="leave-tabs">
              <button className={`leave-tab ${tab === "history" ? "active" : ""}`} onClick={() => { setTab("history"); setCurrentPage(1); }}>Leave History</button>
              <button className={`leave-tab ${tab === "request" ? "active" : ""}`} onClick={() => { setTab("request"); setCurrentPage(1); }}>Leave Request</button>
            </div>
            <button className="filter-btn" onClick={() => setShowFilter(true)}>
              <BsSliders />
              Filter
            </button>

          </div>
        </div>

        {error ? (
          <div className="error">{error}</div>
        ) : (
          <>
            <table className="table">
              <thead>
                <tr>
                  <th className="th">Employee Name</th>
                  <th className="th">Client</th>
                  <th className="th">Start Date</th>
                  <th className="th">End Date</th>
                  <th className="th">No.of Leaves</th>
                  <th className="th">Leave Type</th>
                  <th className="th">Status</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan={7}
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#060505ff",
                        fontSize: "11px",
                        fontWeight: "500",
                        borderTop: "1px solid #eee",
                        borderBottom: "1px solid #eee"
                      }}
                    >
                      Loading leave data...
                    </td>
                  </tr>
                ) : current.length === 0 ? (
                  <tr>
                    <td
                      colSpan={7}
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#060505ff",
                        fontSize: "11px",
                        fontWeight: "500",
                        borderTop: "1px solid #eee",
                        borderBottom: "1px solid #eee"
                      }}
                    >
                      {!selectedClientId ? (
                        "Please select a client to view data"
                      ) : (
                        <>No leave data available for <strong>{selectedClientName}</strong></>
                      )}
                    </td>
                  </tr>
                ) : (
                  current.map((r) => (
                    <tr key={r.id}>
                      <td className="td">{r.employeeName}</td>
                      <td className="td">{r.clientName}</td>
                      <td className="td">{r.startDate}</td>
                      <td className="td">{r.endDate}</td>
                      <td className="td">{r.noOfLeave !== undefined ? r.noOfLeave : r.noOfLeaves} Days</td>
                      <td className="td">{r.leaveType}</td>
                      <td className="td">
                        {tab === "history" ? (
                          <button className={`leave-status-btn ${r.status?.toUpperCase() === "REJECTED" ? "leave-reject" : "leave-accept"}`}>
                            {r.status || "Accepted"}
                          </button>
                        ) : (
                          <select
                            className="leave-status-select"
                            value={
                              requestStatus.has(r.id)
                                ? requestStatus.get(r.id)
                                : r.status
                                  ? r.status.charAt(0).toUpperCase() + r.status.slice(1).toLowerCase()
                                  : "Accepted"
                            }
                            onChange={async (e) => {
                              const newStatus = e.target.value;
                              setRequestStatus((prev) => new Map(prev).set(r.id, newStatus));
                              try {
                                const statusUrl = config.API_BASE_URL + config.LEAVE_STATUS_ENDPOINT.replace("${id}", r.id);
                                const response = await fetch(statusUrl, {
                                  method: 'PUT',
                                  headers: {
                                    Authorization: `Bearer ${userDetails.token}`,
                                    "Content-Type": "application/json",
                                  },
                                  body: JSON.stringify({ status: newStatus }),
                                });
                                if (!response.ok) throw new Error('Failed to update status');

                                setLeaves((prevLeaves) =>
                                  prevLeaves.map((leave) =>
                                    leave.id === r.id
                                      ? { ...leave, status: newStatus.toUpperCase() }
                                      : leave
                                  )
                                );
                              } catch (err) {
                                alert('Failed to update status: ' + err.message);
                                setRequestStatus((prev) => {
                                  const prev2 = new Map(prev);
                                  prev2.delete(r.id);
                                  return prev2;
                                });
                              }
                            }}
                          >
                            <option value="Pending">Pending</option>
                            <option value="Rejected">Rejected</option>
                            <option value="Accepted">Accepted</option>
                          </select>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            <div className="table-footer">
              <div className="record-count">
                Showing {filtered.length === 0 ? 0 : indexOfFirst + 1} to {Math.min(indexOfLast, filtered.length)} of {filtered.length} entries
              </div>

              <div className="pagination">
                <button className="pagination-button" disabled={currentPage === 1} onClick={() => setCurrentPage(1)}>
                  «
                </button>
                <button className="pagination-button" disabled={currentPage === 1} onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}>
                  &lt;
                </button>
                {pageList(currentPage, totalPages, 9).map((p, idx) =>
                  p === '...'
                    ? (
                      <span key={`e-${idx}`} className="pagination-button" style={{ cursor: 'default', opacity: 0.6 }}>…</span>
                    )
                    : (
                      <button key={p} className={`pagination-button ${currentPage === p ? 'active' : ''}`} onClick={() => setCurrentPage(p)}>
                        {p}
                      </button>
                    )
                )}
                <button className="pagination-button" disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}>
                  &gt;
                </button>
                <button className="pagination-button" disabled={currentPage === totalPages} onClick={() => setCurrentPage(totalPages)}>
                  »
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Leaves;
